module.exports = __webpack_public_path__ + "img/1-5.2991d3e5.jpg";